/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/risk-action.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';
import { RiskActionAuditFields } from '@queries/generated/fragments.generated';

const RiskActionRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              TypeId: oldRecord.Type !== 0 ? oldRecord.Type : undefined,
              Type: null,
              Deleted: oldRecord.D === undefined ? newRecord.D : oldRecord.D,
          }
        : oldRecord;
    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              TypeId: newRecord.Type !== 0 ? newRecord.Type : undefined,
              Type: null,
              Deleted: newRecord.D,
          }
        : newRecord;

    const enums: any = {
        TypeId: AuditEnumValues.RiskAction,
    };

    const lookups: any = {
        ResponsibleFunctionId: (action: RiskActionAuditFields) => action?.responsibleFunction?.name,
        OwnerId: (action: RiskActionAuditFields) =>
            action?.owner ? `${action.owner.firstName} ${action.owner.lastName}` : '',
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
            lookups,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { RiskActionRecordChangeGrid };
